import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../../components/label/screen-label/screenLabel";
import Loader from '../../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import moment from "moment";
import { displayErrorToast, isEmpty, isNull, removeSpecialCharAndChangeToPascal } from "../../../../utils/Utils";
import { userListRequest } from '../../../../redux/user/user.action'
import { APP_CONSTANTS } from "../../../../utils/AppConstants";

const AdminUserList = props => {
    const { userListSuccess, userListError } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const [emptyFieldCounter, setEmptyFieldCounter] = useState(0)
    const [searchQuery, setSearchQuery] = useState('')

    useEffect(() => {
        fetchUserList()
    }, [])

    const fetchUserList = () => {
        setLoading(true)
        const data = {
            userType: APP_CONSTANTS.USER_ROLE_TYPE.BUSINESS
        }
        if (!isEmpty(searchQuery)) {
            data.searchQuery = searchQuery
        }
        dispatch(userListRequest(data))
    }

    const handleSearchClick = () => {
        if (isEmpty(searchQuery)) {
            if (Number(emptyFieldCounter) < 3) {
                let currentCounter = emptyFieldCounter
                setEmptyFieldCounter(currentCounter + 1)
                fetchUserList()
            } else {
                displayErrorToast('Please try refreshing the page.')
            }
        } else {
            fetchUserList()
        }
    }

    useEffect(() => {
        if (!isEmpty(userListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(userListError)) {
            setLoading(false)
        }
    }, [userListSuccess, userListError])

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Registered Users' />
                <div className="ol-search-parent-container">
                    <div className="ol-search-row-parent-container">
                        <div className="ol-search-input-container">
                            <input type="text" className="ol-input-no-border" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search" />
                        </div>
                        <div className="ol-search-icon-container" onClick={() => { handleSearchClick() }}>
                            <img src={require('../../../../assets/ic_search_orange.png')} className="img" />
                        </div>
                    </div>
                </div>
                {!isNull(userListSuccess) && !isEmpty(userListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Email</th>
                                <th scope="col" className="text-center">Mobile</th>
                                <th scope="col" className="text-center">User Type</th>
                                <th scope="col" className="text-center">Date</th>
                                {/* <th scope="col" className="text-center">Action</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {userListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.firstName} {element.lastName}</td>
                                    <td className="text-center">{element.email}</td>
                                    <td className="text-center">+{element.mobile}</td>
                                    <td className="text-center">{removeSpecialCharAndChangeToPascal(element.userType)}</td>
                                    <td className="text-center">{moment(element.createdOn).utc().format('DD MMM YYYY')}</td>
                                    {/* <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleViewDetail(element) }}><div className="tr-action-btn">View Message</div></div>
                                        </div>
                                    </td> */}
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(userListError) && <div className="content-error">{userListError.message}</div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AdminUserList